import React from 'react';
import { useTranslation } from 'react-i18next';
import { resolvePath, useNavigate } from 'react-router';

import { datadogRum } from '@datadog/browser-rum';
import { useUser } from 'hooks/useUser';
import { Button } from 'shared/components/Button/Button';
import { Card } from 'shared/components/Card/Card';
import { ArrowUpRightFromSquare } from 'shared/components/icons/ArrowUpRightFromSquare';
import { URLS } from 'constants/urls';
import { Header } from 'shared/components/Header/Header';
import pages from 'pages';
import { guessEnvironment } from 'shared/utils/guessEnvironment';
import { BillingWrapper, Body, BodyText, ButtonWrapper } from './Billing.styles';

export function Billing() {
  const { t } = useTranslation();
  const { selectedAgreement } = useUser();

  const navigate = useNavigate();
  const qaEnvironment = guessEnvironment() === 'qa';
  const billingUrl = qaEnvironment ? URLS.LAUNCH_SSO : URLS.EVERBRIGHT_ONLINE_ACCOUNT;

  const handleClick = () => {
    datadogRum.addAction('sso-billing-url-clicked');
    window.open(billingUrl, '_blank');
  };

  const handleClickAgreementDetails = () => {
    navigate(resolvePath(`${pages.AGREEMENTS}/${selectedAgreement?.id}`, `/${pages.DASHBOARD}`));
  };

  return (
    <BillingWrapper>
      <Header pageName="BILLING" title={t('billing.billing')} />

      <Body>
        {selectedAgreement && (
          <Card
            key={selectedAgreement.homeowner_contract_id}
            title={`${selectedAgreement.product_display_name} #${selectedAgreement.homeowner_contract_id}`}
          >
            <BodyText as="p">{t('billing.makePayments')}</BodyText>

            <ButtonWrapper>
              <Button
                dataTestId={`go-to-billing-button${selectedAgreement.id}`}
                label={t('billing.goToBilling')}
                Icon={ArrowUpRightFromSquare}
                iconRight
                onClick={handleClick}
              />
              <Button
                dataTestId={`view-agreement-button${selectedAgreement.id}`}
                styleVariant="tertiary"
                label={t('billing.viewAgreementDetails')}
                onClick={handleClickAgreementDetails}
              />
            </ButtonWrapper>
          </Card>
        )}
      </Body>
    </BillingWrapper>
  );
}
export default Billing;
